import { useCallback, useState } from 'react';

import { createUrl } from 'app/utils';

import { DashboardListItem } from 'features/dashboard-new';
import { ConditionalLink, Flex, Hr, Typography } from 'components';
import styled from 'styled-components';
import { Icon } from 'components/icon';
import { useMenu } from 'features/menu';
import { useSchool } from 'features/school';

interface SelectorProps {
  dashboards: DashboardListItem[];
  onClick?: () => void;
}

const SelectIcon = styled(Icon)`
  width: 32px;
`;

const DashboardItemLink = styled(ConditionalLink)`
  font-size: 1rem;
  line-height: 1;
  color: ${(props: any) => (props['data-active'] ? 'white' : props.theme.colors.white80)};
  font-weight: ${(props: any) => (props['data-active'] ? 700 : 400)};
  padding: 8px 24px;
  cursor: pointer;

  &:hover {
    color: white;
  }
`;

const Selector = ({ onClick, dashboards }: SelectorProps) => {
  const [dashboardMenuOpened, setDashboardMenuOpened] = useState(false);

  const { currentDashboard } = useMenu();
  const { schoolAlias } = useSchool();

  const handleMenuClick = useCallback(() => {
    setTimeout(() => {
      setDashboardMenuOpened(false);
      if (onClick) onClick();
    }, 1);
  }, []);

  const dashboard = dashboards?.find((d) => d.uuid === currentDashboard);

  return (
    <>
      <Flex flexDirection="column">
        <Flex
          bg="dark_400"
          borderTop="1px solid"
          borderTopColor="dark_150"
          style={{ cursor: dashboards?.length > 1 ? 'pointer' : 'inherit' }}
          py={3}
          px={4}
          onClick={() => setDashboardMenuOpened(!dashboardMenuOpened)}
        >
          <Flex flexDirection="column">
            <Typography type="type0" color={schoolAlias === 'b3' ? 'white50' : 'gray_600'} upper>
              Espaço atual:
            </Typography>

            <Typography type="type3" color="white" fontWeight="bold" mt={2}>
              {dashboard?.name || 'Padrão'}
            </Typography>
          </Flex>

          {dashboards?.length > 1 && <SelectIcon icon={dashboardMenuOpened ? 'chevronUp' : 'chevronDown'} />}
        </Flex>

        {dashboards?.length > 1 && dashboardMenuOpened && (
          <Flex bg="dark_400" flexDirection="column">
            <Typography type="type0" style={{ fontSize: 11 }} upper color={schoolAlias === 'b3' ? 'white50' : 'gray_600'} bg="dark_350" py={2} px={4}>
              Selecione outro espaço
            </Typography>

            <Flex py={2} flexDirection="column">
              {dashboards
                ?.filter((d) => {
                  let show = true;

                  if (currentDashboard && currentDashboard === d.uuid) {
                    show = false;
                  }

                  return show;
                })
                .map((dashboard) => {
                  return (
                    <DashboardItemLink
                      key={`space-${dashboard.uuid}`}
                      type="internal"
                      to={createUrl('dashboard/details', [dashboard.uuid])}
                      onClick={handleMenuClick}
                      data-active={currentDashboard === dashboard.uuid}
                    >
                      {dashboard.name}
                    </DashboardItemLink>
                  );
                })}
            </Flex>
          </Flex>
        )}
      </Flex>

      <Hr color="dark_150" m={0} />
    </>
  );
};

export default Selector;
